// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3gyB1","title":"Info_title__1GBlo","selects":"Info_selects__3TB0S","requiredAsterisk":"Info_requiredAsterisk__1zpAC"};